import api from '../../../api';
import { ResponseSuccess } from '../../../shared/types';
import {
  GetDoNotCallListsPayload,
  CreateDoNotCallListPayload,
  UpdateDoNotCallListPayload,
  GetDoNotCallListDetailsPayload,
  AddPhoneNumberPayload,
  DeletePhoneNumbersPayload,
  BulkDeletePhoneNumbersPayload,
  ExportDoNotCallListPayload,
  ImportPhoneNumbersViaCsvPayload,
} from '../types/do-not-call-list';

export const getDoNotCallLists = async (params: GetDoNotCallListsPayload) =>
  api.get(`/call-dnc`, { params });

export const createDoNotCallList = async (
  payload: CreateDoNotCallListPayload,
) => api.post(`/call-dnc`, payload);

export const updateDoNotCallList = async (
  payload: UpdateDoNotCallListPayload,
) => api.patch(`/call-dnc`, payload);

export const deleteDoNotCallList = async (dncListId: string) =>
  api.delete(`/call-dnc`, { data: { dncListId } });

export const getDoNotCallListDetails = async (
  payload: GetDoNotCallListDetailsPayload,
) => api.post(`/call-dnc/dnclist/get-list`, payload);

export const addPhoneNumber = async (payload: AddPhoneNumberPayload) =>
  api.post(`/call-dnc/dnclist/add-number`, payload);

export const deletePhoneNumbers = async (
  payload: DeletePhoneNumbersPayload,
) => api.delete(`/call-dnc/dnclist/delete-numbers`, { data: payload });

export const bulkDeletePhoneNumbers = async (
  payload: BulkDeletePhoneNumbersPayload,
) => api.delete(`/call-dnc/dnclist/bulk-delete-numbers`, { data: payload });

export const exportDoNotCallList = async (
  payload: ExportDoNotCallListPayload,
) => api.post(`/call-dnc/dnclist/export`, payload);

export const importPhoneNumbersViaCsv = async ({
  dncListId,
  file,
  phoneNumberMapping,
  countryCodeMapping,
}: ImportPhoneNumbersViaCsvPayload) => {
  const data = new FormData();
  data.append('file', file);
  data.append('phoneNumberMapping', phoneNumberMapping);
  data.append('countryCodeMapping', countryCodeMapping);

  return api.post<ResponseSuccess>(`/call-dnc/${dncListId}/import`, data);
};
